<template>
  <v-container fluid class="mt-3 pr-8">
  <v-row>
    <v-col xs="24" sm="12" md="6" lg="6">
    <p class="text-h6 font-weight-light text-uppercase">{{ $t('fees') }}<v-spacer></v-spacer>
     <v-tooltip right>
       <template v-slot:activator="{ on, attrs }">
        <v-badge
        bordered
        color="error"
        overlap
        dot
        :value="filtered"
        >
          <v-icon 
            v-bind="attrs"
            v-on="on" 
            @click="showSearch = !showSearch">
              search
          </v-icon>
        </v-badge>
      </template>
      <span>{{ searchLabel() }}</span>
      </v-tooltip>
    </p>
    </v-col>
    <v-col xs="24" sm="12" md="6" lg="6" align="right">
      <p>
          <a @click="exportToXlsx()">
              {{ $t('exportToXlsx') }}
          </a>
      </p>
    </v-col>
    </v-row>

    <!--    Row for filters    -->
    <v-row v-show="showSearch">

      <!--   SearchInvoiceNumber -->
      <v-col xs="12" sm="6" md="3" lg="3">
        <v-text-field
          :clearable="true"
          dense
          v-bind:label="$t('invoiceNumber')"
          outlined
          prepend-inner-icon="search"
          v-model="filter.invoiceNumber"
        >
        </v-text-field>
      </v-col>
      
      <!--   SearchCirID  -->
      <v-col xs="12" sm="6" md="3" lg="3">
        <v-text-field
          :clearable="true"
          dense
          v-bind:label="$t('cirId')"
          outlined
          prepend-inner-icon="search"
          v-model="filter.cirId"
        >
        </v-text-field>
      </v-col>

      <!--   SearchCIRStatus -->
      <v-col xs="12" sm="6" md="3" lg="3">
        <v-select
          v-model="filter.selectedCirStatus"
          :clearable="true"
          :items="cirStatusItems"
          :item-text="getCirStatusText"
          item-value="cirStatusId"
          v-bind:label="$t('cirStatus')"
          v-bind:no-data-text="$t('noData')"
          persistent-hint
          return-object
          multiple
          dense
          outlined
          prepend-inner-icon="search"
        >
          <template v-slot:selection="{item, index }">
            <span v-if="index === 0">{{ getCirStatusText(item) }}</span>
            <span
              v-if="index === 1"
              class="grey--text text-caption"
            >
              (+{{ filter.selectedCirStatus.length - 1 }})
            </span>
          </template>
        </v-select>
      </v-col>

      <!--   SearchStatus -->
      <v-col xs="12" sm="6" md="3" lg="3">
        <v-select
          v-model="filter.selectedStatus"
          :clearable="true"
          :items="statusItems"
          :item-text="getInvoiceStatusText"
          item-value="statusId"
          v-bind:no-data-text="$t('noData')"
          v-bind:label="$t('status')"
          persistent-hint
          return-object
          multiple
          dense
          outlined
          prepend-inner-icon="search"
        >
        <template v-slot:selection="{item, index }">
          <span v-if="index === 0">{{ getInvoiceStatusText(item) }}</span>
          <span
            v-if="index === 1"
            class="grey--text text-caption"
          >
            (+{{ filter.selectedStatus.length - 1 }})
          </span>
        </template>
        </v-select>
      </v-col>

      <!--   SearchCustomer -->
      <v-col xs="12" sm="6" md="3" lg="3">
        <v-text-field
          :clearable="true"
          dense
          v-bind:label="$t('customer')"
          outlined
          prepend-inner-icon="search"
          v-model="filter.customer"
        >
        </v-text-field>
      </v-col>

      <!--   SearchCustomerPIB -->
      <v-col xs="12" sm="6" md="3" lg="3">
        <v-text-field
          :clearable="true"
          dense
          v-bind:label="$t('customerPib')"
          outlined
          prepend-inner-icon="search"
          v-model="filter.customerPib"
        >
        </v-text-field>
      </v-col>

      <!--   SearchCustomerMB -->
      <v-col xs="12" sm="6" md="3" lg="3">
        <v-text-field
          :clearable="true"
          dense
          v-bind:label="$t('customerMb')"
          outlined
          prepend-inner-icon="search"
          v-model="filter.customerMb"
        >
        </v-text-field>
      </v-col>

      <!--   SearchAmount -->
      <v-col xs="12" sm="6" md="3" lg="3">
        <v-text-field
          :clearable="true"
          dense
          v-bind:label="$t('amount')"
          outlined
          prepend-inner-icon="search"
          v-model="filter.amount"
        >
        </v-text-field>
      </v-col>

      <!--    Date FROM    -->
      <v-col xs="12" sm="6" md="3" lg="3">
        <v-menu
          v-model="menuFrom"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              dense
              outlined
              v-model="filter.dateFrom"
              v-bind:label="$t('dateFrom')"
              prepend-inner-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              clearable
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="filter.dateFrom"
            no-title
            scrollable
            min="2017-01-01"
            max="2050-01-01"
            @input="menuFrom = false"
          >
          </v-date-picker>
        </v-menu>
      </v-col>

      <!--    Date TO    -->
      <v-col xs="12" sm="6" md="3" lg="3">
        <v-menu
          v-model="menuTo"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              dense
              outlined
              v-model="filter.dateTo"
              v-bind:label="$t('dateTo')"
              prepend-inner-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              clearable
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="filter.dateTo"
            no-title
            scrollable
            min="2017-01-01"
            max="2050-01-01"
            @input="menuTo = false"
          >
          </v-date-picker>
        </v-menu>
      </v-col>

      <!--   SearchInvoiceItem -->
      <v-col xs="12" sm="6" md="3" lg="3">
        <v-text-field
          dense
          v-bind:label="$t('keyword')"
          outlined
          prepend-inner-icon="search"
          v-model="filter.inoviceItem"
          clearable
        >
        </v-text-field>
      </v-col>
      <!--   SearchItemsCode -->
      <v-col xs="12" sm="6" md="3" lg="3">
        <v-select v-if="this.$config.SearchItemsCode"
          v-model="filter.itemsCode"
          :items="itemsCodes"
          :item-text="getItemCodeText"
          item-value="itemCodeId"
          v-bind:label="$t('itemCode')"
          v-bind:no-data-text="$t('noData')"
          persistent-hint
          return-object
          dense
          outlined
          prepend-inner-icon="search"
        >
        </v-select>
      </v-col>
      <!--   SearchInvoiceItemName -->
      <v-col xs="12" sm="6" md="3" lg="3">
        <v-text-field
          dense
          v-bind:label="$t('itemName')"
          outlined
          prepend-inner-icon="search"
          v-model="filter.inoviceItemName"
          clearable
        >
        </v-text-field>
      </v-col>
      <!--   Delivery Date FROM    -->
      <v-col xs="12" sm="6" md="3" lg="3">
        <v-menu
          v-model="menuDeliveryFrom"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              dense
              outlined
              v-model="filter.deliveryDateFrom"
              v-bind:label="$t('deliveryDateFrom')"
              prepend-inner-icon="mdi-calendar"
              readonly
              clearable
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="filter.deliveryDateFrom"
            no-title
            scrollable
            min="2017-01-01"
            max="2050-01-01"
            @input="menuDeliveryFrom = false"
          >
          </v-date-picker>
        </v-menu>
      </v-col>

      <!--  Delivery Date TO    -->
      <v-col xs="12" sm="6" md="3" lg="3">
        <v-menu
          v-model="menuDeliveryTo"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              dense
              outlined
              v-model="filter.deliveryDateTo"
              v-bind:label="$t('deliveryDateTo')"
              prepend-inner-icon="mdi-calendar"
              readonly
              clearable
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="filter.deliveryDateTo"
            no-title
            scrollable
            min="2017-01-01"
            max="2050-01-01"
            @input="menuDeliveryTo = false"
          >
          </v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-row justify="end" no-gutters v-show="showSearch">
      <!--   Filter button   -->
        <v-btn 
          dark
          color="#2b5d66"
          large
          class="filter-button"
          @click="filterInvoices(true)"
          >{{ $t('filter') }}</v-btn
        >
        <v-btn
          dark
          color="#2b5d66"
          large
          class="filter-button"
          @click="clearFilter()"
          > {{ $t('clearFilter') }}</v-btn
        >
    </v-row>

    <!--    eInvoices TABLE VIEW    -->
    <v-row>
      <v-col>
        <v-progress-linear indeterminate v-show="loading"></v-progress-linear>

        <v-data-table
          fixed-header
          :height="windowHeight"
          v-model="selected"
          :headers="showHeaders"
          :items="invoices"
          item-key="invoiceId"
          class="elevation-1 grey lighten-3"
          v-bind:no-data-text="$t('noData')"
          v-bind:no-results-text="$t('noData')"
          :footer-props="{
            showFirstLastPage: true,
            'items-per-page-text': $t('rowsPerPage'),
          }"
          :items-per-page="itemsPerPage"
          @update:items-per-page="getItemPerPage"
          @update:options="updatePage($event)"
          :page="currentPage"
        >
          <!--    Table toolbar    -->
          <template v-slot:top>
            <!--<v-toolbar flat dark class="grey darken-3" color="#047083">-->
            <v-toolbar flat dark color="#2b5d66">
              <v-toolbar-title>{{ $t('outputDocuments') }}</v-toolbar-title>
              <v-spacer></v-spacer>
              
              <v-btn icon @click="showSelectHeaders = !showSelectHeaders">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
              <!--<v-switch
                v-model="singleExpand"
                label="Samo jedna proširena"
                class="mt-5"
              ></v-switch>-->
            </v-toolbar>
            <v-toolbar flat dark color="#2b5d66" v-show="showSelectHeaders">
              <v-select v-model="selectedHeaders" :items="headers" v-bind:label="$t('selectColumns')"
               @change="setUsersHeaders"
               v-bind:no-data-text="$t('noData')"
               :item-text="getItemText"
               multiple dense outlined return-object>
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index < 9" color="white"
                    text-color="black" small close
                    @click:close="removeColumn(item)">
                    <span>{{ $t(item.text) }}</span>
                  </v-chip>
                  <span v-if="index === 9">(+{{ selectedHeaders.length - 9 }})</span>
                </template>
              </v-select>
            </v-toolbar>
          </template>

          <!-- Custom HEADER -->
          <template v-for="h in showHeaders" v-slot:[`header.${h.value}`]="{ header }">
            {{ $t(header.text) }} 
          </template>

          <!--  Expanded part of table row  -->
          <!--<template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="pa-3">
              <v-row>
                <v-col>
                  <p class="text-subtitle-2">ID-evi procesa</p>
                </v-col>
              </v-row>
              <ol class="ml-5">
                <li v-for="(wfId, index) in item.wfIds" :key="index">
                  <span class="ml-3">{{ wfId }}</span>

                  <v-divider class="ml-3 mt-1 mb-1"></v-divider>
                </li>
              </ol>
            </td>
          </template>-->

          <template v-slot:[`header.sendFee`]="{ header }">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-simple-checkbox
                v-model="cbSelectAll"
                v-bind="header.sendFee"
                v-on="on" 
                :ripple="false"
                :indeterminate="indeterminate"
                @input="selectAll($event)"
                color="#2b5d66"
                ></v-simple-checkbox>
              </template>
              <span>{{ $t('sendAll') }}</span>
            </v-tooltip>
          </template>

          <!--  Change of pagination. Put 'od' instead 'of'  -->
          <template v-slot:[`footer.page-text`]="items">
            {{ items.pageStart }} - {{ items.pageStop }} {{ $t('of') }}
            {{ items.itemsLength }}
          </template>

          <!--  V-chip for status in data table  -->
          <template v-slot:[`item.percent`]="{ item }">
            <v-chip dark>{{ item.percent + "  %" }}</v-chip>
          </template>

          <!--<template v-slot:item.data-table-select="{ item, isSelected, select }">
            <v-checkbox
                :input-value="isSelected"
                v-model="item.sendFee"
                :readonly="item.statusId != 2 && item.statusId != 21"
                :disabled="item.statusId != 2 && item.statusId != 21"
                @click="setFeeToSend(item)"
                @change="select($event)"
                color="#2b5d66"
            ></v-checkbox>
        </template>-->

        <!-- Open invoice -->
          <template v-slot:item.invoice="{ item }">
            <a @click="openInvoice(item)">
              {{ item.invoice }}
            </a>
          </template>

          <!-- DocumentType -->
          <template v-slot:item.docType="{ item }">
            <span>{{ documentTypeText(item) }}</span>
          </template>

          <!-- CIRStatus -->
          <template v-slot:item.cirStatus="{ item }">
            <span>{{ documentCirStatusText(item) }}</span>
          </template>

          <!-- Status -->
          <template v-slot:item.status="{ item }">
            <span>{{ documentStatusText(item) }}</span>
          </template>
          
          <!-- Format amount -->
          <template v-slot:item.amount="{ item }">
            <span>{{ formatNumberToString(item.amount) }}</span>
          </template>

          <!--  Actions  -->
          <template v-slot:[`item.actions`]="{ item }">
            <v-row>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    v-show="item.statusId == 3 && userPermission('AcceptRejectSalesInvoice')"
                    class="mr-3"
                  >
                    done
                  </v-icon>
                </template>
                <span>{{ $t('approveInvoice') }}</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
              <v-icon 
                v-bind="attrs"
                v-on="on"
                v-show="item.statusId == 3 && userPermission('AcceptRejectSalesInvoice')"
                class="mr-3"> 
              cancel 
              </v-icon>
              </template>
                <span>{{ $t('rejectInvoice') }}</span>
              </v-tooltip>

              <!--<v-icon class="mr-3"> info </v-icon>-->

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon 
                  v-bind="attrs"
                  v-on="on" 
                  v-show="item.statusId != 2  && item.statusId != 9 && item.statusId != 19 && item.statusId != 20 && item.statusId != 21 && userPermission('ViewSalesInvoice')"
                  class="mr-3" 
                  @click.stop.prevent="download(item)"> 
                    file_download 
                  </v-icon>
                </template>
              <span>{{ $t('downloadInvoice') }}</span>
              </v-tooltip>

              <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                  <v-icon 
                  v-bind="attrs"
                  v-on="on" 
                  v-show="item.statusId == 4 && userPermission('StornoSalesInvoice')"
                  class="mr-3" > 
                   highlight_off 
                   </v-icon>
                </template>
              <span>{{ $t('storno') }}</span>
              </v-tooltip>

              <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
              <v-icon
              v-bind="attrs"
              v-on="on" 
              v-show="(item.statusId == 2 || item.statusId == 21) && (loggedUser.username == item.usernameCreateInvoice || item.usernameCreateInvoice.length == 0) && userPermission('DeleteSalesInvoice')"
              @click.stop.prevent="deleteInvoice(item)"
              color="error"> mdi-delete </v-icon>
              </template>
              <span>{{ $t('delete') }}</span>
              </v-tooltip>
            </v-row>
          </template>

        <!-- Fees to send checkbox -->
          <template v-slot:[`item.sendFee`]="{ item }">
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                <v-simple-checkbox
                v-model="item.sendFee"
                v-bind="attrs"
                v-on="on" 
                color="#2b5d66"
                :ripple="false"
                v-if="item.statusId == 2 || item.statusId == 21"
                @input="setFeeToSend(item)"
                ></v-simple-checkbox>
                </template>
                <span>{{ $t('send') }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <template>
</template>

    <!--  Pop up notification  -->
    <v-snackbar v-model="showSnackbar" class="mb-5">
      {{ snackbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="showSnackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  name: "ArchivoFeeOutput",
  components: {},
  data() {
    return {
      windowHeight: window.innerHeight - 250,
      showSearch: false,
      showSelectHeaders: false,
      showSnackbar: false,
      snackbarText: "",
      loading: false,
      itemsPerPage: 10,
      selected: [],
      cbSelectAll: false,
      dateFrom: new Date(0).toISOString().substr(0, 10),
      dateTo: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menuFrom: false,
      menuTo: false,
      menuDeliveryFrom: false,
      menuDeliveryTo: false,
      startDate: "2017-01-01T00:00:00.000Z",
      filter: {
        invoiceNumber: "",
        cirId: "",
        customer: "",
        customerPib: "",
        customerMb: "",
        amount: "",
        dateFrom: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        inoviceItem: "",
        invoiceItemName: "",
        itemsCode: "",
        selectedCirStatus: [],
        selectedStatus: [],
        dateTo: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        deliveryDateFrom: "",
        deliveryDateTo: "",
      },
      statusItems: [],
      cirStatusItems: [],
      itemsCodes: [],
      headers: [],
      selectedHeaders: [],
      allHeaders: {
        invoice: { text: "invoiceNumber", align: "start", value: "invoice" },
        docType: {
          text: "documentType",
          sortable: true,
          value: "docType",
        },
        cirId: {
          text: "cirId",
          sortable: true,
          value: "cirId",
        },
        cirStatus: {
          text: "cirStatus",
          sortable: true,
          value: "cirStatus",
        },
        status: {
          text: "status",
          sortable: true,
          value: "status",
        },
        customer: {
          text: "customer",
          sortable: true,
          value: "customer",
        },
        amount: {
          text: "amount",
          sortable: true,
          value: "amount",
        },
        currency: {
          text: "currency",
          sortable: true,
          value: "currency",
        },
        issueDate: {
          text: "issueDate",
          sortable: true,
          value: "issueDate",
        },
        userCreateInvoice: {
          text: "userCreateInvoice",
          sortable: true,
          value: "userCreateInvoice",
        },
        user: {
          text: "lastChange",
          sortable: true,
          value: "user",
        },
        actions: {
          text: "actions",
          sortable: false,
          value: "actions",
        },
        sendFee: {
          text: "send",
          sortable: false,
          value: "sendFee",
        },
      },
      invoices: [],
      expanded: [],
      singleExpand: false,
      filtered: false,
      //user: this.$route.params.user,
      begin: 0,
      end: this.itemsPerPage,
      indeterminate: false,
      currentPage: 0
    };
  },
  created () {
    if(!this.validation) {
      delete this.allHeaders['userCreateInvoice'];
    }

    this.headers = Object.values(this.allHeaders);
    if(localStorage.getItem('headers'))
      this.selectedHeaders = JSON.parse(localStorage.getItem('headers'));
    else
      this.selectedHeaders = this.headers;
    
    this.init();
  },
  mounted() {
    this.$nextTick(() => {
        window.addEventListener('resize', this.onResize);
    })
  },
  computed: {
    selectedOrganization() {
      return this.$store.getters.organizationId;
    },
    loggedUser() {
      return this.$store.getters.loggedUser;
    },    
    showHeaders () {
      return this.headers.filter(item1 => this.selectedHeaders.some(item2 => item1.text === item2.text));
    },
    validation() {
      return this.userPermission('SendSalesInvoiceToValidation') || this.userPermission('Validation') || this.userPermission('ValidateAndSend');
    }
  },
  methods: {
    searchLabel() {
      if(this.filtered)
        return this.$t('filtered');
      else  
        return this.$t('detailedSearch');
    },
    async init() {
        this.getStatuses();
        this.getCirStatuses();
        await this.getItemsCodes();

        if(localStorage.getItem('feeOutputItemsPerPage'))
            this.itemsPerPage = JSON.parse(localStorage.getItem('feeOutputItemsPerPage'))
        
        if(localStorage.getItem('feeOutputFilter')) {
            this.filter = JSON.parse(localStorage.getItem('feeOutputFilter'))
            this.filterInvoices(true);
        } 
        else if(this.itemsCodes.length > 0) {
            this.filter.itemsCode = this.itemsCodes[0];
            this.filter.selectedStatus = [{statusId: 2}];
            await this.filterInvoices(false);
        }
        else {
            this.getInvoices();
        }
    },
    async filterInvoices(filtered) {
      
      var cirStatusFilter = '';
      for(let i = 0; i < this.filter.selectedCirStatus.length;  i++){
        cirStatusFilter += this.filter.selectedCirStatus[i].cirStatusId + ',';
      }
      cirStatusFilter = cirStatusFilter.substring(0, cirStatusFilter.length - 1);

      var statusFilter = '';
      for(let i = 0; i < this.filter.selectedStatus.length;  i++){
        statusFilter += this.filter.selectedStatus[i].statusId + ',';
      }
      statusFilter = statusFilter.substring(0, statusFilter.length - 1);

      var itemsCode = '';
      if(this.filter.itemsCode != null)
        itemsCode = this.filter.itemsCode.itemCodeId;


      var searchInvoice = {
        organizationId: this.selectedOrganization,
        invoiceNumber: this.filter.invoiceNumber,
        cirId: this.filter.cirId,
        cirStatus: cirStatusFilter,
        status: statusFilter,
        company: this.filter.customer,
        companyPib: this.filter.customerPib,
        companyMb: this.filter.customerMb,
        amount: this.filter.amount,
        item: this.filter.inoviceItem,
        itemName: this.filter.inoviceItemName,
        itemsCode: itemsCode,
        startDate: this.filter.dateFrom,
        endDate: this.filter.dateTo,
        startDeliveryDate: this.filter.deliveryDateFrom,
        endDeliveryDate: this.filter.deliveryDateTo,
        fees: true
      }
      var formData = new FormData();
      formData.append('searchInvoiceJson', JSON.stringify(searchInvoice))

      if(filtered)
        localStorage.setItem('feeOutputFilter', JSON.stringify(this.filter))

      this.loading = true;  
      await this.axios.post('SalesInvoices/GetAllSalesInvoices', formData).then((response) => {  
          this.loading = false;  
          this.filtered = filtered;
          this.invoices = response.data;  
          this.updateSelected();
        })
        .catch(err => console.log(err)); 
    },
    removeColumn(item) {
        this.selectedHeaders = this.selectedHeaders.filter(find => find.text != item.text)
        localStorage.setItem('headers', JSON.stringify(this.selectedHeaders))
    },
    setUsersHeaders() {
      localStorage.setItem('headers', JSON.stringify(this.selectedHeaders))
    },
    download(item){
      this.axios({
        url: 'SalesInvoices/GetSalesInvoicePDF?id=' + item.invoiceId + '&invoiceId=' + item.salesInvoiceId + '&organizationId=' + this.selectedOrganization + '&invoiceNumber=' + item.invoice,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {  
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          var contetnType = response.headers['content-type'];
  
          fileLink.href = fileURL;
          if(contetnType.includes('zip')){
            fileLink.setAttribute('download',  item.invoice + '.zip');
          }
          else{
            fileLink.setAttribute('download',  item.invoice + '.pdf');
          } 
          document.body.appendChild(fileLink);
        
          fileLink.click();
        })
        .catch(err => console.log(err));  
    },
    async deleteInvoice(item) {
      if(await this.$confirm('Da li ste sigurni da želite da obrišete fakturu ' + item.invoice + '?', { title: 'Upozorenje', buttonTrueText: 'Da', buttonFalseText: 'Ne', persistent: true })) {
        this.axios.delete('SalesInvoices/Delete/' + item.invoiceId).then((response) => {
              if(response.status === 200) {
                this.$root.displayNotificationMsg('Obrisana je faktura broj ' + item.invoice, 'success')
                if(this.filtered)
                  this.filterInvoices(true)
                else  
                  this.getInvoices()
              }
            })
            .catch(err => console.log(err))
      }
    },
    setFeeToSend(item) {
        if(item.statusId === 2) {
            if(item.sendFee == null)
                item.sendFee = false;
            this.axios.post('SalesInvoices/SetFeeToSend?invoiceId=' + item.invoiceId + '&status=' + item.sendFee).then((response) => {
                    this.updateSelected();
            })
            .catch(err => console.log(err))
        }
    },
    displayNotificationMsg(msg) {
      this.showSnackbar = true;
      this.snackbarText = msg;
    },
    getInvoices() {  
      var searchInvoice = {
        organizationId: this.selectedOrganization,
        invoiceNumber: null,
        cirId: null,
        cirStatus: null,
        status: null,
        company: null,
        companyPib: null,
        companyMb: null,
        amount: null,
        item: null, 
        itemName: null,
        itemsCode: null,
        fees: true
      }
      var formData = new FormData();
      formData.append('searchInvoiceJson', JSON.stringify(searchInvoice))
      this.loading = true;  
      this.axios.post('SalesInvoices/GetAllSalesInvoices', formData).then((response) => {  
          this.loading = false;  
          this.invoices = response.data;  
          this.updateSelected();
        })
        .catch(err => console.log(err));  
    },
    getDocumentTypes(){
      this.axios.get('InvoiceUtilities/GetDocumentTypes').then((response) => {
        this.documentTypesItems = response.data;
        this.documentTypesItems = this.documentTypesItems.filter(t =>  { return t.documentTypeId >= 5 })
      })
      .catch(err => console.log(err));
    },
    getStatuses(){
      this.axios.get('InvoiceUtilities/GetStatuses?type=Fee').then((response) => {
        this.statusItems = response.data;
      })
      .catch(err => console.log(err));
    },
    getCirStatuses(){
      this.axios.get('InvoiceUtilities/GetCirStatuses').then((response) => {
        this.cirStatusItems = response.data;
      })
      .catch(err => console.log(err));
    },
    getItemsCodes() {
        return new Promise((resolve) => {            
            this.itemsCodes = this.loggedUser.itemCode.filter(c =>  { return c.organizationId ==  this.selectedOrganization || c.organizationId == -1});
            resolve();
        });
    },
    userPermission(action) {
      const isFound = this.loggedUser.permission.some(element =>{
        if(element.permission === action && element.organizationId === this.selectedOrganization)
          return true;
      });
      return isFound;
    },
    openInvoice(item) {
      this.$router.push({ name: 'InvoiceForm', query: {id: item.invoiceId }})
    },
    exportToXlsx() {
      var formData = new FormData();
      formData.append('invoicesJson', JSON.stringify(this.invoices))
      this.axios.post('SalesInvoices/ExportViewToExcel?validation=false', formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }, responseType: 'blob',
      }).then(response => {
        if(response && response.status === 200) {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
  
          fileLink.href = fileURL;
          fileLink.setAttribute('download',  this.$t('outputView') + '.xlsx');
          document.body.appendChild(fileLink);

          fileLink.click();
        }
      })
      .catch((error) => { 
          console.log("Error: " + error);
          console.log(error.response.data); 
      })        
    },
    async clearFilter() {
      this.filter = {
        invoiceNumber: "",
        cirId: "",
        customer: "",
        customerPib: "", 
        customerMb: "",
        amount: "",
        dateFrom: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        inoviceItem: "",
        inoviceItemName: "",
        itemsCode: this.itemsCodes[0],
        selectedCirStatus: [],
        selectedStatus: [],
        dateTo: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        }
        localStorage.removeItem('feeOutputFilter')
        await this.filterInvoices(false)
    },
    formatNumberToString(value) {
        value = value.toString().replace(",", ".");
        var formatter = new Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2});
        return formatter.format(value);
    },
    getItemPerPage(val) {
      localStorage.setItem('feeOutputItemsPerPage', JSON.stringify(val))
    },
    selectAll(props) {
        let drafts = (this.invoices.slice(this.begin, this.end)).filter(invoice => { return invoice.statusId === 2 })
        drafts.forEach(invoice =>{
            if(invoice.sendFee != this.cbSelectAll) {
                invoice.sendFee = this.cbSelectAll;
                this.setFeeToSend(invoice);
            }
        })
        this.selected = (this.invoices.slice((props.page - 1) * this.itemsPerPage, this.itemsPerPage * props.page)).filter(invoice => { return invoice.statusId === 2 && invoice.sendFee })
    },
    updateSelected() {
        let drafts = (this.invoices.slice(this.begin, this.end)).filter(invoice => { return invoice.statusId === 2 })
        this.selected = (this.invoices.slice(this.begin, this.end)).filter(invoice => { return invoice.statusId === 2 && invoice.sendFee })
        
        if(this.selected.length > 0 && drafts.length == this.selected.length) {
            this.cbSelectAll = true;
            this.indeterminate = false;
        }            
        else if(this.selected.length > 0) {
            this.indeterminate = true;
        }
        else {
            this.cbSelectAll = false;
            this.indeterminate = false;
        }
     },
    updatePage(props) {
        this.begin = (props.page - 1) * this.itemsPerPage;
        this.end = this.itemsPerPage * props.page;
        this.updateSelected();
    },
    getItemText(item) {
      return this.$t(item.text);
    },
    getCirStatusText(item) {
      if(localStorage.getItem('language') === 'eng')
        return item.cirStatusEng;
      else
        return item.cirStatus;
    },
    getInvoiceStatusText(item) {
      if(localStorage.getItem('language') === 'eng')
        return item.invoiceStatusEng;
      else
        return item.invoiceStatus;
    },
    documentTypeText(item) {
      if(localStorage.getItem('language') === 'eng')
        return item.docTypeEng;
      else
        return item.docType;
    },
    documentStatusText(item) {
      if(localStorage.getItem('language') === 'eng')
        return item.statusEng;
      else
        return item.status;
    },
    documentCirStatusText(item) {
      if(localStorage.getItem('language') === 'eng')
        return item.cirStatusEng;
      else
        return item.cirStatus;
    },
    getItemCodeText(item) {
      if(localStorage.getItem('language') === 'eng')
        return item.codeEng;
      else
        return item.code;
    },
    onResize() {
      this.windowHeight = window.innerHeight - 250
    }
  },
};
</script>

<style scoped>
.filter-button {
  max-height: 39px !important;
  margin-right: 15px;
}
.search-field {
  width: 1px;
}
</style>